import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../../service';
import { CommonService } from '../../../service/common/common.service';
@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    CommonService.showLoader();
    let tokenDetails = "Bearer "+this.storageService.getItem('token') ;
    if (!/^(http|https):/i.test(request.url)) {
      let url = '';
      url = '';
      const headers: any = {
        'Authorization': `${tokenDetails}`,
        'Cache-Control': 'no-cache',
      }
      request = request.clone({
        url,
        headers: new HttpHeaders(headers)
      });
    }
    if (request.method === 'POST' || request.method === 'PUT') {
      let body = request.body;
      if (body) {
        request = request.clone({
          body: body
        });
      }
    }
    if (this.storageService.getItem('token')){
      const headers: any = {
        'Authorization': `${tokenDetails}`
      }
      let url = request.url;
    request = request.clone({
      url,
      headers: new HttpHeaders(headers)
    });
    return next.handle(request);
    }
    else{
      let url = request.url;
    request = request.clone({
      url
    });
    return next.handle(request);
    }
  }
}


